import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import {
  useStyles,
} from './styles';

export const ApartmentSkeleton = () => {
  const styles = useStyles();
  return (
    <div className={styles.apartmentSkeleton}>
      <Skeleton variant="rectangular" className="status" width="100%" height={36} />
      <Skeleton variant="rectangular" className="round" width="100%" height={140} />
      <div className={styles.labels}>
        <Skeleton variant="rectangular" className="round" width={46} height={22} />
        <Skeleton variant="rectangular" className="round" width={46} height={22} />
        <Skeleton variant="rectangular" className="round" width={46} height={22} />
      </div>
      <Skeleton variant="rectangular" className="round" width="60%" height={23} />
      <Skeleton variant="rectangular" className="round" width="100%" height={40} />
      <div className={styles.deal}>
        <Skeleton variant="rectangular" className="round" width="100%" height={16} />
        <Skeleton variant="rectangular" className="round" width="100%" height={32} />
        <Box className="row" gap="8px">
          <Skeleton variant="circular" width={28} height={28} />
          <Box className="row" flexDirection="column" gap="0">
            <Skeleton variant="rectangular" className="round" width={50} height={28} />
          </Box>
        </Box>
        <Skeleton variant="rectangular" className="round" width="100%" height={16} />
      </div>
    </div>
  );
};
